import React from 'react';

import Filter from './Filter';

export default function Filters({ filters, filtersState, updateFiltersState }) {
  return (
    <div className="flex items-center gap-3 w-full md:w-auto flex-wrap">
      {filters.map((filter) => {
        return (
          <Filter
            key={filter.title}
            filter={filter}
            filtersState={filtersState}
            updateFiltersState={updateFiltersState}
          />
        );
      })}
    </div>
  );
}
